var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('institution-sign-in-button',{attrs:{"loading":_vm.loading},on:{"sign-in":_vm.ipAddressSignIn}},[_c('span',[_vm._v("Log in through your Institution")])])}
var staticRenderFns = []

export { render, staticRenderFns }